var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 457,
    viewBox: "0 0 360 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.118 40.5172C272 24.3997 254.019 10.8306 234.669 0C250.957 23.3917 260.523 51.7851 260.523 82.3846C260.523 162.078 195.692 226.909 115.998 226.909C52.0324 226.909 0 278.951 0 342.908C0 394.817 34.2699 438.862 81.3671 453.629C92.7397 455.236 104.312 456.073 115.998 456.073C181.02 456.073 242.152 430.75 288.127 384.775C334.103 338.8 359.425 277.668 359.425 212.646C359.425 147.625 334.103 86.4924 288.127 40.5172H288.118ZM115.989 371.605C93.548 371.605 75.2815 353.349 75.2815 330.898C75.2815 308.448 93.548 290.191 115.989 290.191C138.43 290.191 156.696 308.448 156.696 330.898C156.696 353.349 138.439 371.605 115.989 371.605Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.272,
    cy: 330.471,
    r: 40.7212,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSvg);
export default __webpack_public_path__ + "static/media/WhiteSvg.ee4cd046eaf400d120047a88a40b9e02.svg";
export { ForwardRef as ReactComponent };